'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function VisitorTracker() {
  const pathname = usePathname();

  useEffect(() => {
    // Log visitor on page load
    const logVisitor = async () => {
      try {
        await fetch('/api/log-visitor', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            timestamp: new Date()?.toISOString(),
            page: pathname,
            referrer: document.referrer || 'direct',
            userAgent: navigator.userAgent,
          }),
        });
      } catch (error) {
        console.error('Failed to log visitor:', error);
      }
    };

    logVisitor();
  }, [pathname]);

  return null; // This component doesn't render anything
}